import React from 'react';

import classes from './TitledImage.module.scss';
import InBodyScaleImage from '../../../../../assets/image/bg-inbody-scale.webp';

const TitledImage = () => {
  return (
    <div className={classes.container}>
      <img className={classes.image} src={InBodyScaleImage} alt="inbody scale" />
      <p className={classes.description}>
        <span>Unlock your body&apos;s profile:</span>
        <span className={classes.primaryText}>muscle, fat, hydration, metabolism —</span>
        <span>revealed in minutes.</span>
        <span className={classes.line} />
      </p>
    </div>
  );
};

export { TitledImage };
